import React from 'react'
import AddBankAccount from '../forms/AddBankAccount'
import SleepSelectOption from '../../components/SleepSelectOption'
import { usePaymentStore } from 'stores/paymentStore'
import SfRadio from 'components/overrides/SfRadio'

const BankAccount: React.FC = () => {
  const { selectedPaymentProfile, setSelectedPaymentProfile } = usePaymentStore()

  return (
    <SleepSelectOption
      selected={selectedPaymentProfile === `New Bank Account`}
      onClick={() => setSelectedPaymentProfile( `New Bank Account` )}
      data-testid="snl-selected-payment-profile"
    >
      <div className="flex gap-2">
        <SfRadio checked={selectedPaymentProfile === `New Bank Account`} />
        <p className="font-light">{`Pay by bank account`}</p>
      </div>
      {selectedPaymentProfile === `New Bank Account` && <AddBankAccount />}
    </SleepSelectOption>
  )
}

export default BankAccount